import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeService = () => {
  const [ServiceTopUser, setServiceTopUser] = useState([]);
  const [ServiceUser, setServiceUser] = useState([]);
  const navigate = useNavigate();

  //   service top api
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://admin.gosaviadvanceddentalclinic.com/api/getservicetop"
      );
      setServiceTopUser(response.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getservice");
      setServiceUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deleteservice/${userId}`);

      setServiceUser((prevUsers) =>
        prevUsers.filter((user) => user.id !== userId)
      );

      toast.error("Data Deleted Successfully!");
      navigate("/Service");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          {ServiceTopUser.map((user) => {
            return (
              <div>
                <h3>
                  {user.heading}{" "}
                  <Link to={`/Service-header-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-btn"></i>
                  </Link>
                </h3>
                <p>{user.para}</p>
              </div>
            );
          })}
          <Link to="/Service-add">
            <button className="Banner-button">Add</button>
          </Link>
          <div className="row table-home">
            <table>
              <thead>
                <tr>
                  <th className="col-lg-1">Sr.No</th>
                  <th className="col-lg-2">Image</th>
                  <th className="col-lg-2">Title</th>
                  <th className="col-lg-4">Description</th>
                  <th className="col-lg-1">Action</th>
                </tr>
              </thead>
              <tbody>
                {ServiceUser.map((user, index) => {
                  return (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>
                        {" "}
                        <img
                          src={user.serviceimage}
                          alt="Service"
                          style={{ width: "150px", height: "100px" }}
                        />
                      </td>
                      <td>{user.title}</td>
                      <td>
                        <p
                          dangerouslySetInnerHTML={{ __html: user.description }}
                        ></p>
                      </td>
                      <td>
                        <Link to={`/Service-view/` + user.id}>
                          <i
                            title="View"
                            className="fa-regular fa-eye action-btn"
                            style={{ color: "blue" }}
                          ></i>
                        </Link>
                        <Link to={`/Service-edit/` + user.id}>
                          <i className="fa-regular fa-pen-to-square action-btn"></i>
                        </Link>
                        <span onClick={() => deleteUser(user.id)}>
                          <i
                            title="Delete"
                            className="fa-solid fa-trash-can action-btn"
                            style={{ color: "red" }}
                          ></i>
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ServiceAdd = () => {
  const [ServiceData, setServiceData] = useState({
    title: "",
    description: "",
    serviceimage: null,
  });
const [previewImage, setPreviewImage] = useState("");
  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setServiceData((prev) => ({ ...prev, [name]: value }));
  };

 const imageHandler = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
      const maxSize = 2 * 1024 * 1024; // 2MB

      // Validate type
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }

      // Validate size
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }

      // Optional: Dimension check
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = () => {
        if (img.width > 1350 || img.height > 700) {
          toast.error("Image dimensions should not exceed 1350x700.");
          URL.revokeObjectURL(objectUrl);
          return;
        }

        setServiceData((prev) => ({ ...prev, serviceimage: file }));
        setPreviewImage(objectUrl); // Show preview
      };
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (
      !ServiceData.title ||
      !ServiceData.description ||
      !ServiceData.serviceimage
    ) {
      toast.error("All fields, including an image, are required!");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("title", ServiceData.title);
      formData.append("description", ServiceData.description);
      formData.append("serviceimage", ServiceData.serviceimage);

      await axios.post("https://admin.gosaviadvanceddentalclinic.com/api/createservice", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Data added successfully!");
      navigate("/Service"); // Redirect after success
    } catch (error) {
      console.error("Error adding Service:", error);
      toast.error("Failed to add Service!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12" />
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
          <div className="add-banner">
            <Link to="/Service">
              <i className="fa-solid fa-xmark"></i>
            </Link>
            <h3>Add Service Data</h3>
            <form
              className="row"
              onSubmit={submitForm}
              encType="multipart/form-data"
            >
               <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="serviceimage">Upload Service Image</label>
                <input
                  type="file"
                  id="serviceimage"
                  name="serviceimage"
                  accept="image/*"
                  onChange={imageHandler}
                />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "40%",
                      height: "350px",
                      borderRadius: "8px",
                      display: "block",
                      margin: "10px auto"
                    }}
                  />
                )}
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="title">Title</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={ServiceData.title}
                  id="title"
                  name="title"
                  placeholder="Enter Title"
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="description">Description</label>
                <textarea
                  onChange={inputHandler}
                  value={ServiceData.description}
                  id="description"
                  name="description"
                  placeholder="Enter Description"
                  rows="4"
                ></textarea>
              </div>
             
              <div className="mobilesubmitform">
                <button type="submit">Add Data</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export const HomeServiceEdit = () => {
  const [Serviceuser, setServiceUser] = useState({
    title: "",
    description: "",
    serviceimage: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [editorLoaded, setEditorLoaded] = useState(false);

  // Load CKEditor
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
    script.async = true;
    script.onload = () => setEditorLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (window.CKEDITOR) {
        Object.keys(window.CKEDITOR.instances).forEach((instance) =>
          window.CKEDITOR.instances[instance].destroy(true)
        );
      }
    };
  }, []);

  // Fetch existing data
  const fetchServiceData = async () => {
    try {
      const response = await axios.get(
        `https://admin.gosaviadvanceddentalclinic.com/api/getoneservice/${id}`
      );
      if (response.data.success) {
        setServiceUser(response.data.data);
        if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
          window.CKEDITOR.instances.editor.setData(
            response.data.data.description
          );
        }
      }
    } catch (error) {
      console.error("Error fetching Service data!", error);
      toast.error("Failed to load Service data.");
    }
  };

  useEffect(() => {
    if (editorLoaded) fetchServiceData();
  }, [id, editorLoaded]);

  useEffect(() => {
    if (editorLoaded && !window.CKEDITOR.instances.editor) {
      window.CKEDITOR.replace("editor");
    }
  }, [editorLoaded]);

  useEffect(() => {
    if (editorLoaded && window.CKEDITOR.instances.editor) {
      window.CKEDITOR.instances.editor.setData(Serviceuser.description || "");
    }
  }, [Serviceuser.description, editorLoaded]);

  // Set preview image if already available
  useEffect(() => {
    if (
      Serviceuser.serviceimage &&
      typeof Serviceuser.serviceimage === "string"
    ) {
      setPreviewImage(Serviceuser.serviceimage);
    }
  }, [Serviceuser.serviceimage]);

  // Handle input change
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setServiceUser({ ...Serviceuser, [name]: value });
  };

  // Handle image change
   const handleImageChange = (e) => {
     const file = e.target.files[0];
   
     if (file) {
       const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
       const maxSize = 2 * 1024 * 1024; // 2MB
   
       // ✅ Type check
       if (!allowedTypes.includes(file.type)) {
         toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
         return;
       }
   
       // ✅ Size check
       if (file.size > maxSize) {
         toast.error("Image size should be under 2MB.");
         return;
       }
   
       // ✅ Optional: Dimension check (example: max 1920x1080)
       const img = new Image();
       const objectUrl = URL.createObjectURL(file);
       img.src = objectUrl;
   
       img.onload = () => {
         const { width, height } = img;
   
         // Example check (adjust if needed)
         if (width > 850 || height > 500) {
           toast.error("Image dimensions should not exceed 850x500.");
           URL.revokeObjectURL(objectUrl); // Clean up
           return;
         }
   
         setSelectedImage(file);
         const reader = new FileReader();
         reader.onloadend = () => {
           setPreviewImage(reader.result);
         };
         reader.readAsDataURL(file);
       };
     }
   };

  // Submit form
  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", Serviceuser.title);
    formData.append("description", window.CKEDITOR.instances.editor.getData());
    if (selectedImage) {
      formData.append("serviceimage", selectedImage);
    }

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updateservice/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Data updated successfully!");
        navigate("/Service");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating the service:", error);
      toast.error("Failed to update service.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm} encType="multipart/form-data">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/Service">
                <button type="button" className="close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
            <div className="form-group">
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  name="serviceimage"
                  onChange={handleImageChange}
                  accept="image/*"
                />
                <br />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "40%",
                      height: "200px",
                    }}
                  />
                )}
              </div>
              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  value={Serviceuser.title}
                  onChange={changeHandler}
                  className="form-control"
                  name="title"
                  required
                />
                <br />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea id="editor"></textarea>
                <br />
              </div>

           
            </div>

            <div className="modal-footer">
              <Link to="/Service">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const HomeServiceView = () => {
  const [ServiceUser, setServiceUser] = useState({
    title: "",
    description: "",
    serviceimage: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const ServiceData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getoneservice/${id}`
        );
        setServiceUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    ServiceData();
  }, [id]);

  return (
    <div className="container-fluid admin-view">
      <div className="row arpi">
        <div className="col-lg-3 col-md-3 col-sm-12"></div>

        <div className="col-lg-7 col-md-7 col-sm-12 view-sec">
          <Link to="/Service" className="back-btn">
            <i className="fa-solid fa-arrow-left"></i> Back
          </Link>
          <br />
          <br />

          <h4>
            {ServiceUser.title}{" "}
            <Link to={`/Service-edit/` + ServiceUser.id}>
              <i className="fa-regular fa-pen-to-square"></i>
            </Link>
          </h4>
          <br />
          <p dangerouslySetInnerHTML={{ __html: ServiceUser.description }}></p>
          <br/>
          <img
            src={ServiceUser.serviceimage}
            alt="Service"
            style={{ width: "100%", height: "500px" }}
          />

        </div>
      </div>
    </div>
  );
};

export const ServiceHeaderEdit = () => {
  const [Serviceuser, setServiceUser] = useState({
    heading: "",
    para: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setServiceUser({ ...Serviceuser, [name]: value });
    // console.log(user);
  };

  useEffect(() => {
    const editData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getoneservicetop/${id}`
        );
        // console.log(response.data);
        setServiceUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    editData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = {
      heading: Serviceuser.heading,
      para: Serviceuser.para,
    };

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updateservicetop/${id}`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data.success) {
        setServiceUser(formData);
        toast.success("Data updated successfully!");
        navigate("/Service");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exampleModalLabel"
      style={{
        display: "block",
        paddingRight: 18,
        marginTop: 90,
        paddingBottom: 50,
      }}
      aria-modal="true"
    >
      <div className="modal-dialog" role="document">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit
              </h5>
              <Link to="/Service">
                <button type="button" className="close" aria-label="Close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Heading</label>
                <input
                  type="text"
                  value={Serviceuser.heading}
                  onChange={changeHandler}
                  className="form-control"
                  name="heading"
                />
                <br />
              </div>

              <div className="form-group">
                <label>Paragraph</label>
                <textarea
                  type="text"
                  value={Serviceuser.para}
                  onChange={changeHandler}
                  className="form-control"
                  name="para"
                  rows={4}
                />
                <br />
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Service">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
